import { FormControl } from '@angular/forms';

export type TFormControlWorkInstruction = {
  isActive: FormControl<boolean | null>;
  name: FormControl<string | null>;
  totalProcessCycleTime: FormControl<string | null>;
};

export type TWorkInstructionForm = {
  isActive: boolean;
  name: string;
  totalProcessCycleTime: string | null;
};

export type TWorkInstructionBulkEditForm = Partial<Pick<TWorkInstructionForm, 'isActive'>>;
export type TWorkInstructionBulkEditRequest = TWorkInstructionBulkEditForm & { id: number };

export interface IWorkInstruction {
  createdAt: string;
  id: number;
  isActive: boolean;
  name: string;
  totalProcessCycleTime: number | null;
}

export interface IItemWorkInstructionAssignment extends IAddItemWorkInstructionAssignment {
  id: number;
  boardId: number;
  itemId: number;
  guideId: number;
}

export interface IAddItemWorkInstructionAssignment {
  boardId: number;
  itemId: number;
  guideId: number;
  startDateForRecurringUpdate?: string | null;
}

export interface IDeleteItemWorkInstructionAssignment {
  id: number;
  startDateForRecurringUpdate?: string | null;
}

export type TAddWorkInstruction = Omit<IWorkInstruction, 'id' | 'createdAt'>;

export interface IEditWorkInstruction {
  dto: TAddWorkInstruction;
  id: number;
}

export enum EWorkInstructionEditorSidebar {
  steps = 0,
  templates = 1,
}

export interface IWorkInstructionEditor {
  id: number;
  name: string;
}
